@if (getWorkType === 'multiple') {
  @for (answer of document.document_answers; track answer.id; let i = $index) {
    <div class="question-answer" data-cy="work-question-item">
      <div class="question-number" data-cy="work-question-num">
        設問{{ i + 1 }}
        @if (isCompassAnswer) {
          <span class="required">必須</span>
        }
      </div>
      <div class="block-element">
        @if (!isReadMore) {
          <p class="preserve-line-break" data-cy="work-question-content">
            {{ answer.work_question.content.description || answer.work_question.content }}
          </p>
        } @else {
          <app-read-more
            [content]="answer.work_question.content.description || answer.work_question.content"
            [collapsedLength]="149"
          ></app-read-more>
        }
        @if (answer.work_question.image) {
          <div class="question-image">
            <img data-cy="work-question-image" src="{{ answer.work_question.image.thumbnail }}" />
          </div>
        }
        <p class="answer-title">回答</p>
        @if (!isReadMore) {
          <p class="preserve-line-break" data-cy="work-question-answer">{{ answer.content }}</p>
        } @else {
          <app-read-more [content]="answer.content" [collapsedLength]="149"></app-read-more>
        }
        @if (answer.upload_files.length > 0) {
          <div class="answer-images">
            <app-files-view-teacher [files]="answer.upload_files"></app-files-view-teacher>
          </div>
        }
      </div>
    </div>
  }
} @else {
  <p class="content-title">本文</p>
  <div class="block-element">
    @if (!isReadMore) {
      <p class="preserve-line-break" data-cy="work-content" appConvertLink>
        {{ document.content }}
      </p>
    } @else {
      <app-read-more [content]="document.content" [collapsedLength]="999"></app-read-more>
    }
    <div class="thumb">
      <app-files-view-teacher [files]="document?.upload_files"></app-files-view-teacher>
    </div>
  </div>
}
@if (hasCategory || hasMarks) {
  <div class="category-marks">
    @if (hasCategory) {
      <div class="category-text">
        <p data-cy="category-name">{{ categoryName }}</p>
      </div>
    }
    @if (hasMarks) {
      <div class="marks">
        @for (mark of marks; track mark.id) {
          <div class="mark">
            <img data-cy="mark-icon" [src]="mark.icon" />
            <p data-cy="mark-name">{{ mark.name }}</p>
          </div>
        }
      </div>
    }
  </div>
}
